export class SubscriptionLog {
  constructor(public subscribedFrame: number,
              public unsubscribedFrame: number = Number.POSITIVE_INFINITY) {
  }
}


// WEBPACK FOOTER //
// ./~/rxjs/src/testing/SubscriptionLog.ts